import { Component, OnInit } from '@angular/core';
import {MenuAsideService} from '../../../core/_base/layout';

@Component({
  selector: 'kt-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

  constructor(private menuAsideService: MenuAsideService) {
    this.menuAsideService.pathname$.next(window.location.pathname);

  }

  ngOnInit() {
  }

}
